<template>
  <section class="feature dark" id="feature">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-5">
          <h5>{{ t('Enjoy Unlimited Benefits With Just A Single Price!') }}</h5>
          <h1 class="text-white mb-4">{{ t('Why Pay Monthly?') }}</h1>
          <p>{{ t("Veximus gives you more than just web designs, our one-stop web subscription service provides everything you need to create impressive websites. Let's explore why you should join thousands of business owners who have opted to pay monthly for their business websites.") }}</p>
        </div>
        <div class="col-md-6 offset-md-1">
          <div class="row">
            <div class="col-6 col-sm-4 col-md-6 col-lg-4">
              <font-awesome-icon icon="hdd" />
              <h4>
                {{ t('Fully') }}<br />
                {{ t('Managed') }}
              </h4>
            </div>
            <div class="col-6 col-sm-4 col-md-6 col-lg-4">
              <font-awesome-icon icon="piggy-bank" />
              <h4>
                {{ t('Low') }}<br />
                {{ t('Startup Cost') }}
              </h4>
            </div>
            <div class="col-6 col-sm-4 col-md-6 col-lg-4">
              <font-awesome-icon icon="life-ring" />
              <h4>
                {{ t('Lifetime') }}<br />
                {{ t('Support') }}
              </h4>
            </div>
            <div class="col-6 col-sm-4 col-md-6 col-lg-4">
              <font-awesome-icon icon="monitor-heart-rate" />
              <h4>
                {{ t('24 Hours') }}<br />
                {{ t('Monitoring') }}
              </h4>
            </div>
            <div class="col-6 col-sm-4 col-md-6 col-lg-4">
              <font-awesome-icon icon="sync" />
              <h4>
                {{ t('Always') }}<br />
                {{ t('Up To Date') }}
              </h4>
            </div>
            <div class="col-6 col-sm-4 col-md-6 col-lg-4">
              <font-awesome-icon icon="cloud-upload-alt" />
              <h4>
                {{ t('Routine') }}<br />
                {{ t('Backup') }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.feature {
  padding: 8rem 0 5rem;

  h5 {
    color: #999;
  }

  p {
    @media (max-width: 767.98px) {
      margin-bottom: 3rem;
    }
  }

  svg {
    align-items: center;
    border-radius: 1.65rem;
    border: solid 1px rgb(255 255 255 / 25%);
    color: #fff;
    display: flex;
    height: 80px;
    justify-content: center;
    margin-bottom: 1.5rem;
    padding: 1.5rem;
    position: relative;
    width: 80px;

    @media (max-width: 767.98px) {
      margin-left: auto;
      margin-right: auto;
    }
  }

  h4 {
    color: #fff;
    font-size: 1.25rem;
    line-height: 1.25em;
    margin-bottom: 3rem;

    @media (max-width: 767.98px) {
      text-align: center;
    }
  }
}
</style>

<script>
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const { t } = useI18n({
      messages: {
        'en-MY': {
          '24 Hours': '24 Hours',
          'Enjoy Unlimited Benefits With Just A Single Price!': 'Enjoy Unlimited Benefits With Just A Single Price!',
          'Startup Cost': 'Startup Cost',
          'Up To Date': 'Up To Date',
          'Why Pay Monthly?': 'Why Pay Monthly?',
          "Veximus gives you more than just web designs, our one-stop web subscription service provides everything you need to create impressive websites. Let's explore why you should join thousands of business owners who have opted to pay monthly for their business websites.": "Veximus gives you more than just web designs, our one-stop web subscription service provides everything you need to create impressive websites. Let's explore why you should join thousands of business owners who have opted to pay monthly for their business websites.",
          Always: 'Always',
          Backup: 'Backup',
          Fully: 'Fully',
          Lifetime: 'Lifetime',
          Low: 'Low',
          Managed: 'Managed',
          Monitoring: 'Monitoring',
          Routine: 'Routine',
          Support: 'Support'
        },
        'zh-MY': {
          '24 Hours': '24小时',
          'Enjoy Unlimited Benefits With Just A Single Price!': '只需一个价格即可享受无限的优惠！',
          'Startup Cost': '启动成本',
          'Up To Date': '版本更新',
          'Why Pay Monthly?': '为何按月支付？',
          "Veximus gives you more than just web designs, our one-stop web subscription service provides everything you need to create impressive websites. Let's explore why you should join thousands of business owners who have opted to pay monthly for their business websites.": '微星不仅仅为您提供了站点的开发与设计，我们的网络订阅服务更是提供了一站式的工具，让您有能力创造优秀、令人影响深刻的网站。如今，数以千计的业主已经选择了以每月订阅的模式来架构他们的企业网站，让我们来看一看为什么您也应该加入我们，成为每月服务订阅者的一员。',
          Always: '永久性',
          Backup: '云端备份',
          Fully: '伺服器',
          Lifetime: '终身性',
          Low: '超低廉',
          Managed: '全权托管',
          Monitoring: '实时监控',
          Routine: '周期性',
          Support: '技术支援'
        },
        'ms-MY': {
          '24 Hours': 'Pemantauan',
          'Enjoy Unlimited Benefits With Just A Single Price!': 'Manfaat Tanpa Had Dengan Satu Harga!',
          'Startup Cost': 'Rendah',
          'Up To Date': 'Kini',
          'Why Pay Monthly?': 'Kenapa Bayar Bulanan?',
          "Veximus gives you more than just web designs, our one-stop web subscription service provides everything you need to create impressive websites. Let's explore why you should join thousands of business owners who have opted to pay monthly for their business websites.": 'Veximus bukan hanya memberikan perkhidmatan reka bentuk web, kami menyediakan semua perkhidmatan yang anda perlu untuk membina laman web yang menarik. Tahukan kenapa ribuan pemilik perniagaan telah memilihi model bayaran bulanan untuk laman web perniagaan mereka.',
          Always: 'Dikemas',
          Backup: 'Sandaran',
          Fully: 'Diuruskan',
          Lifetime: 'Sokongan',
          Low: 'Kos',
          Managed: 'Sepenuhnya',
          Monitoring: '24 Jam',
          Routine: 'Rutin',
          Support: 'Selamanya'
        }
      }
    });

    return { t };
  }
};
</script>

